/**
 * <GroupedLiveSessionsListSection> — les séances rangées par jour (template).
 *
 * Un jour = un libellé de section + UNE carte-liste, une ligne par séance. C'est le petit format
 * de l'accueil (`<SessionRow>`), pas la grosse `<LiveSessionCard>` à menu « ⋮ » : l'espace parent
 * ne montre plus qu'une seule forme de séance, et toute la ligne presse pour ouvrir ses actions.
 *
 * Aucune ombre : « Tous mes lives » n'est qu'une liste, elle n'a rien à mettre en avant
 * (`CLAUDE.md`, « Une seule surface en relief par page »).
 *
 * Les groupes arrivent calculés par le view-model (`UILiveSessionGroup[]`) — aucun regroupement,
 * aucune date manipulée ici.
 */
import React from "react"

import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { Stack } from "../../atoms/containers/Stack"
import { CardList } from "../../molecules/CardList"
import { SessionRow } from "../../molecules/SessionRow"
import { type UILiveSession, type UILiveSessionGroup } from "../../../ports/primary/ui/types"

export type GroupedLiveSessionsListSectionProps = {
    groups: UILiveSessionGroup[]
    /** Ouvre les actions de la séance touchée. Absent → les lignes ne pressent pas. */
    onSelectSession?: (session: UILiveSession) => void
    /** Chaque ligne écrit son « Rattrapage de l'absence du … » (`<SessionRow showRecoveryInfo>`). Défaut `false`. */
    showRecoveryInfo?: boolean
    testID?: string
}

export function GroupedLiveSessionsListSection(props: GroupedLiveSessionsListSectionProps) {
    const { groups, onSelectSession, showRecoveryInfo = false, testID } = props

    return (
        <Stack gap="6" testID={testID}>
            {groups.map((group) => (
                <Stack key={group.id} gap="3">
                    {/* Le jour d'aujourd'hui se dit en vert : c'est le seul repère de la page. */}
                    <SectionLabel color={group.isToday ? "success" : "text-muted"}>{group.title}</SectionLabel>
                    <CardList>
                        {group.sessions.map((session) => (
                            <SessionRow
                                key={session.id}
                                session={session}
                                timeOnly
                                showRecoveryInfo={showRecoveryInfo}
                                onPress={onSelectSession != null ? () => onSelectSession(session) : undefined}
                            />
                        ))}
                    </CardList>
                </Stack>
            ))}
        </Stack>
    )
}
